<template>
    <div class="light-grey-bg">
    <v-container>
        <v-layout row wrap justify-center class="program">
            <v-flex xs12>
                <p class="small-title"><a @click="$router.push({name: 'programs'})">Programas</a></p>
            </v-flex>
            <v-flex xs12 class="program-title">
                <h1>PROGRAMA BECADO PARA CUIDO DE NIÑOS EN CAROLINA DEL SUR<br/>(SC CHILD CARE PROGRAMA DE BECAS)</h1>
            </v-flex>
<v-flex md8>
                <v-card class="program-info" style="margin: 0 auto;">
                    <img class="program-image" src="/images/dss-sq.png" />
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 align-self-center align-center>
                                <div style="margin: 0 auto;">
                                    <table>
                                        <tr>
                                            <td><img src="/images/icons/day.png"/></td>
                                            <td>Duración del día</td>
                                            <td>Día completo</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/year.png"/></td>
                                            <td>Longitud del año</td>
                                            <td>Escuela de verano, año escolar, día extendido</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/car.png"/></td>
                                            <td>Transporte</td>
                                            <td>Varía</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/curriculum.png"/></td>
                                            <td>Plan de estudios</td>
                                            <td>Varía</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/cost.png"/></td>
                                            <td>Costo</td>
                                            <td>$ 6- $ 20 por niña(o) por semana</td>
                                        </tr>
                                        <tr>
                                            <td><img src="/images/icons/location.png"/></td>
                                            <td>Ubicación</td>
                                            <td>Centro de cuidado infantil, Centro de cuidado infantil familiar en el hogar</td>
                                        </tr>
                                    </table>
                                </div>
                            </v-flex>
                            <v-flex class="program-overview" xs12>
                                <div style="margin: 0 auto; background: #1b3675;color: white;">
                                    <h3>DESCRIPCCIÓN DEL PROGRAMA</h3>
                                    <p>
                                         El Programa de Becas Preescolares de SC, operado por el Departamento de Servicios Sociales de SC, ofrece apoyo de matrícula para cuidado infantil a familias elegibles de bajos ingresos para que sus padres puedan trabajar o asistir a la escuela o entrenamiento. El ingreso de los padres debe ser bajo el 55% del ingreso medio del estado para ingresar al programa de cupones.m.
                                    </p>
                                </div>
                            </v-flex>
                            <v-flex xs12>
                                    <v-carousel>
                                      <v-carousel-item
                                        v-for="(item,i) in items"
                                        :key="i"
                                        :src="item.src"
                                      ></v-carousel-item>
                                    </v-carousel>                               
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>TRANSPORTE OFRECIDO</h3>
                                <p>
                                    El Programa de Becas Preescolares de SC solo paga por servicios de cuidado infantil y no cubre el transporte. Sin embargo, algunos programas de cuidado infantil 
                                    ofrecen transporte de cuidado infantil dentro de sus propios programas.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>TIPO DE SERVICIO</h3>
                                <p>
                                    El Programa de Becas Preescolares de SC paga los servicios de cuidado infantil en instalaciones de cuidado infantil y hogares de cuidado infantil familiar que están 
                                    inscritos en ABC Quality para familias que cumplen con los criterios de elegibilidad del programa.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>COSTO</h3>
                                <p>
                                    Cuando se determina que es elegible para recibir asistencia para el cuidado infantil con el Programa de Becas Preescolares de SC, se les puede solicitar a los 
                                    padres que paguen un copago directamente al programa de cuidado infantil. Los copagos oscilan entre $ 6 y $ 20 por niño, por semana según el 
                                    ingreso mensual de la familia, el tamaño de la familia y si los servicios para los que califican requieren un copago. Las categorías de financiación como 
                                    TANF y Foster Care no tienen copagos para los clientes. Las tarifas de pago de SC Voucher se pagan hasta las tarifas máximas según la Encuesta de tarifas de 
                                    mercado más reciente.
                                </p>
                            </v-flex>
                            <v-flex xs12 style="text-align: left">
                                <h3>ELEGIBILIDAD PARA SERVICIOS</h3>
                                <p> 
                                    El Programa de Becas Preescolares de SC ofrece una amplia variedad de categorías de financiación. La elegibilidad es específica para la categoría a la que se aplica la familia. 
                                    En general, el criterio para solicitar asistencia de cuidado infantil es que el padre debe estar trabajando, en la escuela o en un programa de capacitación, 
                                    debe tener cuidado infantil por un mínimo de 15 horas por semana y la familia debe cumplir con todos los requisitos e ingresos. Criterios basados 
                                    en el ingreso mensual y el tamaño de la familia. Algunas categorías tienen criterios más estrictos. Si una familia siente que puede ser elegible para 
                                    asistencia infantil a través del Programa de Becas Preescolares de SC, puede llamar al 1-800-476-0199 para obtener más información.
                                </p>
                                <v-btn round large=true color="primary" @click="$router.push({name: 'eligibility'})"><span class="btn-white">VERIFICAR ELEGIBILIDAD</span></v-btn>
                                <hr>
                            </v-flex>
                        </v-layout>        
                    </v-card-title>
                    <v-card-actions>
                        <v-btn flat color="primary" @click="$router.push({name: 'programs'})">&lt; VOLVER A LOS PROGRAMAS</v-btn>
                    </v-card-actions>
                </v-card>
            </v-flex>
            <v-flex md4>
                <v-layout row wrap>
                    <v-flex class="" xs12>
                        <v-card class="contact-sidebar" color="primary" style="color: white;text-align:left;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <h2>Contacto</h2>
                                            <p class="bold">1535 Confederate Avenue<br/>Columbia, SC 29201</p>
                                            
                                            <p>Teléfono: <a href="tel:1-800-476-0199">1-800-476-0199</a></p>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                    <v-flex xs12>
                        <v-card class="quote-sidebar" color="lightblue" style="color: white;">
                            <v-card-title>
                                <v-layout row wrap>
                                    <v-flex xs12>
                                        <img src="/images/icons/quote-icon.png"/>
                                        <p>
                                            “Estoy muy agradecido por el Programa de Becas Preescolares de SC. Realmente ha mejorado la vida de mi hijastra. Cuando la vida nos arrojó una bola curva 
                                            y la llevó con nosotros a tiempo completo, tener acceso a los cupones nos permitió brindarle un ambiente de aprendizaje estable en el cuidado de 
                                            niños mientras trabajábamos ”
                                        </p>
                                        <br/>
                                        <span>- Padre usando el Voucher SC</span>
                                    </v-flex>
                                </v-layout>
                            </v-card-title>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-flex>
        </v-layout>
    </v-container>
    <div class="grey-bg">
        <v-container>  
        <v-card>
            <v-card-title class="cta-card">
                <v-layout row wrap justify-center align-center>
                    <v-flex xs12 sm4 class="red-section">
                        <img alt="" src="/images/icons/icon.png"/>
                    </v-flex>
                    <v-flex xs12 sm8 class="cta-card-text">
                        <v-layout row wrap justify-center align-center>
                            <v-flex xs10>
                                <div class="red-section-content">
                                    <h2>¡ENCUENTRE OPCIONES DE PRE-K CERCA DE TI!</h2>
                                    <p>Encuentre las escuelas preescolares que ofrecen programas para los cuales su hijo es elegible. Simplemente ingrese su dirección para encontrar un centro ubicado cerca de usted.</p>
                                </div>
                            </v-flex>
                            <v-flex xs2 class="arrow-img">
                                <a href="/provider-search"><img alt="Provider Search" src="/images/icons/arrow.png"/></a>
                            </v-flex>
                        </v-layout>  
                    </v-flex>
                </v-layout>
            </v-card-title>
        </v-card>
        </v-container>
    </div>
    </div>
</template>
<style scoped>

    .program{
        margin: 0 auto;
        text-align: center;
    }
    .red-section{
        background: #e94342;
        text-align: center;
    }

    .cta-card{
        padding: 0;    
    }

    .cta-card-text{
        padding: 15px 15px;
    }
</style>

<script>
     export default {
    data () {
      return {
        items: [
          {
            src: '/images/slides/video2.png'
          },
          {
            src: '/images/slides/video3.png'
          },
          {
            src: '/images/slides/video4.png'
          }
        ]
      }
    }
  }
</script>